import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "asDayTabs"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "icon-prev" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  class: "asDayTabs_wrapper",
  ref: "containerEl"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "asDayTab_title" }
const _hoisted_7 = {
  key: 0,
  class: "asDayTab_progress"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "icon-next" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showTabs)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToDay('prev'))),
          class: _normalizeClass(["asDayTabs_prev-day", {
        '-disabled': !_ctx.showPrevDayButton
      }])
        }, _hoisted_3, 2),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (d, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: _normalizeClass(["asDayTabs_tab asDayTab", { '-current': d.id === _ctx.currentDayId }]),
              id: `tab_day${d.id}`
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(d.title), 1),
              (d.id === _ctx.currentDayId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "• " + _toDisplayString(_ctx.progress) + "% " + _toDisplayString(_ctx.$t('progress')), 1))
                : _createCommentVNode("", true)
            ], 10, _hoisted_5))
          }), 128))
        ], 512),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToDay('next'))),
          class: _normalizeClass(["asDayTabs_next-day", {
        '-disabled': !_ctx.showNextDayButton
      }])
        }, _hoisted_9, 2)
      ]))
    : _createCommentVNode("", true)
}